import React from "react"
import { useTranslation } from "react-i18next"

import classes from "./OhCoupons.module.scss"

const OhCoupons = props => {
  const { order } = props

  const [t] = useTranslation()

  const coupons =
    order.couponData.filter(c => c.type !== "comboset")

  if (coupons.length === 0) return null

  return (
    <div className={classes["delivery-address"]}>
      <span>{t("جزئیات_کوپن")}</span>
      <div>
        {t("کد_ها")}:{" "}
        <b>
          {coupons.map((c, cIndex) =>
            `${c.couponCode}${cIndex === coupons.length - 1 ? "" : " - "}`)
          }
        </b>
      </div>
    </div>
  )
}

export default OhCoupons